<script>
  export default {
    name: 'ModalVue',
    methods: {
      close() {
        this.$emit('close');
      },
      onKeydown(e) {
        if (e && (e.key === 'Escape' || e.key === 'Esc')) {
          this.close();
        }
      },
    },
    mounted() {
      window.addEventListener('keydown', this.onKeydown);
    },
    beforeUnmount() {
      window.removeEventListener('keydown', this.onKeydown);
    },
  };
</script>

<template>
  <transition name="modal-fade">
    <div class="modal-backdrop-5" @click.self="close">
      <div class="modal-5"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-headerr"
          id="modalTitle"
        >
          <slot name="header">
            This is the default tile!
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
          </button>
        </header>

        <section
          class="modal-body"
          id="modalDescription"
        >
          <slot name="body">
            This is the default body!
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            This is the default footer!
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>


<style scoped>
.modal-backdrop-5 {
  position: fixed;
  top:0; right:0; bottom:0; left:0 ;
  background-color: rgba(0, 0, 0, 0.7) !important;
  z-index: 1000;
  display: flex !important;
  justify-content: center !important;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 3% !important;
}
.modal-5 {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 0.5);
  display: flex !important;
  flex-direction: column;
  width: 90% !important;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  padding: 0 !important;
  z-index: 1001;
}

.modal-5 > .modal-header,
.modal-5 > .modal-body,
.modal-5 > .modal-footer {
  padding: 20px;
}

.modal-body {
  overflow-y: auto;
}


  .modal-header {
    padding: 15px;
    display: flex;
    gap: 10px;
  }

  .modal-headerr {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #000;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 14px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #000000;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #000000;
    border: 1px solid #000000;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>